var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"button",class:{
    'button--primary': _vm.primary,
    'button--disabled': _vm.disabled,
    'button--white': _vm.white,
    'button--loading': _vm.loading
  },attrs:{"disabled":_vm.disabled,"type":"button"}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.loading)?_c('img',{staticClass:"ml-20 img-loading",attrs:{"src":require("@/assets/icons/loading-indicator.gif"),"width":"30"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }